.table-footer-cell {
    composes: cell from '../styles.module.css';
    position: relative;
    color: var(--grey-dk);
    white-space: nowrap;
    font-weight: 500;
}

.table-footer-cell.compact {
    padding: 8px;
}

.bordered,
.border--right {
    border-right: var(--border-hairline);
}

.data-type--integer {
    text-align: right;
    justify-content: flex-end;
}

.align-right {
    text-align: right;
    justify-content: flex-end;
}

.align-center {
    text-align: center;
    justify-content: center;
}
